module.exports = __webpack_public_path__ + "static/media/text-size.17c37db6.svg";